import {
  CREATE_CONTROL_REQUEST,
  CREATE_CONTROL_SUCCESS,
  CREATE_CONTROL_FAILURE,
  UPDATE_CONTROL_REQUEST,
  UPDATE_CONTROL_SUCCESS,
  UPDATE_CONTROL_FAILURE,
  DELETE_CONTROL_REQUEST,
  DELETE_CONTROL_SUCCESS,
  DELETE_CONTROL_FAILURE,
  GET_UNIQUE_CONTROL_REQUEST,
  GET_UNIQUE_CONTROL_SUCCESS,
  GET_UNIQUE_CONTROL_FAILURE,
  CLEAR_CONTROL, 
  CREATE_CONTROLS
} from '../constants'
import { clear } from "redux-localstorage-simple"

export const defaultControlState = {
  control: {},
  controls: [],
  uniqueControls: [],
  pending: false,
  createSuccess: false,
  createControlsSuccess: false,
  updateSuccess: false,
  deleteSuccess: false,
  fetchUniqueSuccess: false,
  riskId: undefined,
}

export default (state = defaultControlState, action) => {

  var newState = {...state}

  switch (action.type){
    case CREATE_CONTROL_REQUEST:
      newState.pending = true;
      newState.createSuccess = false;
      return newState;
    case CREATE_CONTROL_SUCCESS:
      newState.control = action.body;
      newState.riskId = action.riskId;
      newState.pending = false;
      newState.createSuccess = true;
      return newState;
    case CREATE_CONTROL_FAILURE:
      newState.pending = false;
      newState.createSuccess = false;
      return newState;
    case UPDATE_CONTROL_REQUEST:
      newState.pending = true;
      newState.updateSuccess = false;
      return newState;
    case UPDATE_CONTROL_SUCCESS:
      newState.control = action.body;
      newState.riskId = action.riskId;
      newState.pending = false;
      newState.updateSuccess = true;
      return newState;
    case UPDATE_CONTROL_FAILURE:
      newState.pending = false;
      newState.updateSuccess = false;
      return newState;
    case DELETE_CONTROL_REQUEST:
      newState.pending = true;
      newState.deleteSuccess = false;
      return newState;
    case DELETE_CONTROL_SUCCESS:
      newState.control = action.body;
      newState.riskId = action.riskId;
      newState.pending = false;
      newState.deleteSuccess = true;
      return newState;
    case DELETE_CONTROL_FAILURE:
      newState.pending = false;
      newState.deleteSuccess = false;
      return newState;
    case GET_UNIQUE_CONTROL_REQUEST:
      newState.pending = true;
      newState.fetchUniqueSuccess = false;
      return newState;
    case GET_UNIQUE_CONTROL_SUCCESS:
      newState.uniqueControls = action.body;
      newState.pending = false;
      newState.fetchUniqueSuccess = true;
      return newState;
    case GET_UNIQUE_CONTROL_FAILURE:
      newState.pending = false;
      newState.fetchUniqueSuccess = false;
      return newState;
    case CLEAR_CONTROL:
      newState = defaultControlState;
      clear(); //Clears the Redux LocalStorage
      return newState;
    case CREATE_CONTROLS.request:
      newState.pending = true;
      newState.createControlsSuccess = false;
      return newState;
    case CREATE_CONTROLS.success:
      newState.controls = action.data;
      newState.riskId = action.data[0].risk_id;
      newState.pending = false;
      newState.createControlsSuccess = true;
      return newState;
    case CREATE_CONTROLS.failure:
      newState.pending = false;
      newState.createControlsSuccess = false;
      return newState;
    default:  return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/control.js